"use client";

import { Icon, Text } from "@zapier/design-system";
import React from "react";
import Image from "next/image";
import { crossDomainImageLoader } from "src/utils/images";

import styles from "./TemplateCard.module.css";
import { ZapCardTemplate } from "../ZapCard/ZapCard";

interface TemplateProps {
  createTemplate?: (key: string) => void;
  template: ZapCardTemplate;
}

export const TemplateCard = ({ createTemplate, template }: TemplateProps) => {
  if (!template.slug) return null;

  const wrapperProps = createTemplate
    ? { onClick: () => createTemplate(template.slug) }
    : { href: `/templates/details/${template.slug}` };

  return (
    <a className={styles.wrapper} {...wrapperProps}>
      <div className={styles.imageWrapper}>
        {template.previewImage ? (
          <Image
            loader={crossDomainImageLoader}
            src={template.previewImage.url}
            alt={template.previewImage.title}
            fill
            style={{
              objectFit: "cover",
              objectPosition: "center center",
            }}
          />
        ) : null}
      </div>
      <div className={styles.content}>
        <div className={styles.titleWrapper}>
          <Text type="SectionHeader">{template.name}</Text>
        </div>
        {template.description ? (
          <div className={styles.description}>
            <Text type="Body1">{template.description}</Text>
          </div>
        ) : null}
        <div className={styles.buttons}>
          <Text type="Body4" color="UiPrimaryStrongest">
            Check it out
          </Text>
          <Icon size={20} name="arrowBigRight" color="UiPrimaryStrongest" />
        </div>
      </div>
    </a>
  );
};
